import {
  IonCard,
  IonCardContent,
  IonIcon,
  IonRouterLink,
  IonButton,
} from '@ionic/react';
import { briefcase, time, close } from 'ionicons/icons';
import { useRecentViews, type RecentViewItem } from '@/stores/useRecentViews';
import BoringAvatar from '@/components/BoringAvatar';
import './RecentViews.css';

function ItemRow({ item }: { item: RecentViewItem }) {
  const to = item.type === 'candidate' ? `/candidate/${item.id}` : `/jobs/${item.id}`;
  return (
    <IonRouterLink routerLink={to}>
      <IonCard button className="bp-recent-card">
        <IonCardContent className="bp-recent-row">
          {item.type === 'candidate' ? (
            <div className="bp-recent-avatar">
              <BoringAvatar name={item.title} size={40} />
            </div>
          ) : (
            <IonIcon icon={briefcase} color="primary" className="bp-recent-icon" />
          )}
          <div className="bp-recent-text">
            <div className="bp-recent-title">{item.title}</div>
            {item.subtitle && <div className="bp-recent-sub">{item.subtitle}</div>}
          </div>
          <IonIcon icon={time} color="medium" className="bp-recent-time" />
        </IonCardContent>
      </IonCard>
    </IonRouterLink>
  );
}

function Section({ title, items }: { title: string; items: RecentViewItem[] }) {
  if (items.length === 0) return null;
  return (
    <div className="bp-recent-section ion-padding-horizontal ion-padding-bottom">
      <div className="bp-section-head">
        <h2 className="bp-heading bp-section-title">{title}</h2>
      </div>
      {items.map((item) => (
        <ItemRow key={`${item.type}:${item.id}`} item={item} />
      ))}
    </div>
  );
}

export function RecentViews() {
  const items = useRecentViews((s) => s.items);
  const clear = useRecentViews((s) => s.clear);

  const candidates = items.filter((i) => i.type === 'candidate');
  const jobs = items.filter((i) => i.type === 'job');

  if (items.length === 0) return null;

  return (
    <div className="bp-recent ion-padding-top">
      <div className="bp-section-head ion-padding-horizontal">
        <h2 className="bp-heading bp-section-title">Recently Viewed:</h2>
        <IonButton fill="clear" size="small" onClick={clear}>
          <IonIcon icon={close} slot="start" />
          Clear
        </IonButton>
      </div>
      <Section title="Professionals" items={candidates} />
      <Section title="Jobs & projects" items={jobs} />
    </div>
  );
}
